module.exports = __webpack_public_path__ + "media/assets/Pencil2-a977a288f3af4ce5693624e50f1c7af6.svg";